import { ProductKeys } from '~/types/ProductEnums';

export function isProd() {
  return process.env.CURRENT_ENV === 'prod';
}

export function isPreview() {
  return process.env.CURRENT_ENV === 'preview';
}

const getEcoPart = (attributes, selectedLocale) => {
  if (selectedLocale !== 'fr') {
    return;
  }

  const ecoPart = attributes[ProductKeys.ecoPart];
  if (ecoPart && ecoPart > 0) {
    return `ECO-PART ${ecoPart} €`;
  }
};

export const generateVariantString = (variant: { attributesRaw: Array<any> }, selectedLocale) => {
  const attributes: Record<string, string | any> = Array.isArray(variant.attributesRaw)
    ? variant.attributesRaw.reduce((acc, { value, name }) => Object.assign(acc, { [name]: value }), {})
    : {};

  const ecoPart = getEcoPart(attributes, selectedLocale);
  if (ecoPart) {
    return ecoPart;
  }

  const unit = attributes[ProductKeys.capacityUnit]
    ? attributes[ProductKeys.capacityUnit]?.label?.[selectedLocale] || ''
    : attributes?.capacity_unit || '';

  const type = attributes[ProductKeys.capacityType]
    ? attributes[ProductKeys.capacityType]?.label?.[selectedLocale] || ''
    : attributes?.capacity_type || '';

  const color =
    (typeof attributes?.color?.label?.[selectedLocale] === 'string' && attributes?.color?.label?.[selectedLocale]) ||
    '';

  const bundleCapacity = attributes?.products?.length || null;

  if (bundleCapacity) {
    return `${bundleCapacity} ${attributes['capacity-unit']?.label?.[selectedLocale]}`;
  }

  return attributes?.capacity
    ? `${attributes.capacity}${unit} ${type ? '• ' : ''}${type} ${color ? '• ' : ''}${color}`
    : `${color}`;
};

export const capitalizeFirstLetter = (string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
};

/**
 * Replaces all spaces and single quotes in a string with underscores.
 *
 * @param {string} str - The string to be modified.
 * @returns {string} The modified string with spaces and single quotes replaced by underscores.
 */
export const replaceSpacesWithUnderscores = (str) => {
  return str.replace(/ /g, '_').replace(/'/g, '_');
};
